import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { Text } from 'common';

import { BlockKeyValuesField } from '../../../ConfigFields/KeyValues/KeyValuesField';

export function InformationExtractionExamplesFormField() {
  return (
    <Accordion variant="elevation">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Text variant="heading5">Examples</Text>
      </AccordionSummary>
      <AccordionDetails>
        <BlockKeyValuesField
          fieldName="config.examples"
          label="Examples of desired extraction cases (optional)"
          addRowHelperText="example"
          keyValueFieldNames={{
            key: {
              name: 'input',
              label: 'Input',
            },
            value: {
              name: 'output',
              label: 'Output',
            },
          }}
          required={false}
          getDefaultNewRow={() => ({
            id: crypto.randomUUID(),
            input: '',
            output: '',
          })}
        />
      </AccordionDetails>
    </Accordion>
  );
}
